<template>
	
<div class="links" v-if="links.length">

	<div class="links-icon"></div>

	<div class="links-content">

		<div class="links-content-title">Further information</div>
		
		<div class="links-content-item" v-for="(link, index) in links" :key="index">

			<a :href="link.url" target="_blank">{{ link.text }}</a>

		</div>

	</div>

</div>

</template>

<script>

export default {

	props: ['links']
	
}

</script>

<style scoped>

.links {
	padding: 16px;
	border-radius: 8px;
	background-color: rgba(254, 204, 102, 0.36);
	padding-left: 77px;
	margin-top: 32px;
}

.links-icon {
	width: 45px;
	height: 45px;
	position: absolute;
	left: 16px;
	top: 16px;
	background-image: url(~@/assets/aid/common/info.svg);
}

.links-content {
	min-height: 45px;
}

.links-content-title {
	text-transform: uppercase;
	color: #343434;
	font-size: 12px;
	font-weight: 600;
	letter-spacing: 1px;
	margin-top: 4px;
	margin-bottom: 10px;
}

.links-content-item {
	height: 18px;
	line-height: 18px;
	background-image: url(~@/assets/aid/common/link.png);
	background-repeat: no-repeat;
	background-position: 0px 0px;
	background-size: auto 16px;
	padding-left: 24px;
	margin-bottom: 4px;
}

.links-content-item:last-child {
	margin-bottom: 0px;
}

.links-content-item a {
	color: #343434;
	font-size: 16px;
	font-weight: 400;
}

.links-content-item a:hover {
	text-decoration: underline;
}

</style>